<dl class="py-6 space-y-6">
    <div class="flex items-center justify-between">
        <dt class="text-[14px] font-[400] text-[#707D96]">Subtotal:</dt>
        <dd class="text-[14px] font-medium text-black">
            {{ getOriginalSubtotalWithTax() | formatPrice }}
        </dd>
    </div>
    <div
        class="flex items-center justify-between"
        *ngIf="stripeSurchargePercent > 0 && isStripeSelected"
    >
        <dt class="text-[14px] font-[400] text-[#707D96]">Stripe Fee:</dt>
        <dd class="text-[14px] font-medium text-black">
            {{ getStripeSurchargeAmount() | formatPrice }}
        </dd>
    </div>

    <div class="flex items-center justify-between">
        <p class="text-[14px] font-[400] text-[#707D96]">
            Shipping with protection:
        </p>
        <p class="text-[14px] font-medium text-black">Included</p>
    </div>
    <div
        class="flex items-center justify-between"
        *ngIf="cart.discounts && cart.discounts.length"
    >
        <dt class="text-[14px] font-[400] text-[#707D96]">Discount:</dt>
        <dd class="text-[14px] font-medium text-black">
            {{ getTotalDiscountWithTax() | formatPrice }}
        </dd>
    </div>
    <!-- <div class="flex items-center justify-between"> //TODO: Later will be needed to add shipping
        <dt class="text-[14px] font-[400] text-[#707D96]">
            Shipping
            <span class="text-[14px] font-[400] text-[#707D96]"
                >(<span class="" *ngFor="let line of cart.shippingLines">{{
                    line.shippingMethod.name
                }}</span
                >)</span
        >
        </dt>
        <dd class="text-[14px] font-medium text-black">
            {{ cart.shippingWithTax | formatPrice }}
        </dd>
    </div>
    -->
    <div
        class="flex items-center justify-between border-t border-gray-200 pt-6"
    >
        <dt class="text-[18px] font-[400] text-[#707D96]">Total</dt>
        <dd class="text-[18px] font-medium text-black">
            <span *ngIf="stripeSurchargePercent > 0 && isStripeSelected">
                {{ getTotalWithStripeSurcharge() | formatPrice }}
            </span>
            <span *ngIf="!(stripeSurchargePercent > 0 && isStripeSelected)">
                {{ cart.totalWithTax | formatPrice }}
            </span>
        </dd>
    </div>
</dl>
